import PropTypes from 'prop-types'
import React, { useState } from "react";
import { TextField } from "@mui/material";


const BaseInput = ({
    dataTest,
    mainColor = "var(--text-muted)",
    size,
    width,
    height = 50,
    type,
    label,
    placeholder,
    required,
    inputValue,
    setInputValue,
    pattern,
    error,
    disabled,
    readOnly,
    fullWidth,
    labelColor,
    multiline,
    rows,
    minRows,
    min,
    step,
}) => {

    const [errorMessage, setErrorMessage] = useState(false);
    const handleChange = (e) => {
        if (!setInputValue) {
            return;
        }
        setInputValue(e.target.value)
        if (e.target.validity.valid) {
        setErrorMessage(false);
        } else {
        setErrorMessage(true);
        }
    };

    return (
        <TextField
            data-test={dataTest}
            size={size}
            disabled={disabled}
            fullWidth={!!fullWidth}
            sx={{ '& .MuiInputBase-root': {
                    height: multiline ? undefined : height,
                    alignItems: multiline ? 'flex-start' : undefined,
                },
                "& .MuiFormLabel-root": {color: labelColor || mainColor},
                '& label.Mui-focused': {
                    color: labelColor || "var(--border-strong)",
                },
                '& .MuiInput-underline:after': {
                    borderBottomColor: "var(--border-strong)",
                },
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: "var(--border-strong)",
                    },
                    '&:hover fieldset': {
                        borderColor: mainColor,
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: mainColor,
                    },
                },

                "& label.Mui-focused": {color: labelColor || mainColor},
                "& .MuiOutlinedInput-notchedOutline": {borderColor: mainColor},
                    '& .MuiInputBase-input': {
                        color: readOnly ? 'var(--text-disabled)' : mainColor,
                        WebkitTextFillColor: readOnly ? 'var(--text-disabled)' : mainColor,
                        textAlign: 'left',
                    },
                    width: fullWidth ? '100%' : (width ? `${width}ch` : undefined),
            }}
            required={!!required}
            type={type}
            label={label}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            error={errorMessage}
            helperText={
                errorMessage ? error : ""
            }
            multiline={!!multiline}
            rows={rows}
            minRows={minRows}
            slotProps={{
                inputLabel: type === "datetime-local" || type === "time" ? { shrink: true } : undefined,
                htmlInput: {
                    ...(pattern || {}),
                    readOnly: !!readOnly,
                    ...(min != null ? { min } : {}),
                    ...(step != null ? { step } : {}),
                },
            }}
        />
    );

};

BaseInput.propTypes = {
    'dataTest': PropTypes.string.isRequired,
    'inputValue': PropTypes.string.isRequired,
    'setInputValue': PropTypes.func,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    fullWidth: PropTypes.bool,
    labelColor: PropTypes.string,
    multiline: PropTypes.bool,
    rows: PropTypes.number,
    minRows: PropTypes.number,
    min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default BaseInput;